import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=413f128a"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports